@if (isLoading()) {
    <div class="flex justify-center flex-wrap mt-8">
        <p-progressSpinner />
    </div>
} @else {
    <div class="flex flex-wrap gap-4 mt-2">
        @for (link of links(); track link.integrationId) {
            <app-product-group-integration-row
                [productGroupId]="productGroupId()"
                [link]="link"
                (linkChange)="onLinkChange($event)"
            />
        } @empty {
            <div class="max-w-md w-full mt-8 p-4 flex flex-col justify-center items-center bg-gray-50 dark:bg-gray-800 rounded-lg shadow-md">
                <i class="fas fa-plug fa-2x text-gray-600 dark:text-gray-300"></i>
                <h3 class="mt-4 text-lg font-semibold text-gray-800 dark:text-gray-100">
                    {{ 'integration.link.no-integrations-available' | translate }}
                </h3>
                <p class="mt-2 text-sm text-gray-600 dark:text-gray-400 text-center">
                    {{ 'integration.link.contact-admin' | translate }}
                </p>
            </div>
        }
    </div>
}
